import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';

// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { ToastrModule } from 'ngx-toastr';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MastersComponent } from './components/masters/masters.component';
import { DisplayBoardRegistrationModule } from './components/display-board-registration/display-board-registration.module';
import { DisplayBoardRegistrationComponent } from './components/display-board-registration/display-board-registration.component';
import { MessagifyUserComponent } from './components/messagify-user/messagify-user.component';

@NgModule({
  declarations: [
    AppComponent,
    MastersComponent,
    DisplayBoardRegistrationComponent,
    MessagifyUserComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
//     // for HttpClient use:
    LoadingBarHttpClientModule,
//     // for Router use:
    LoadingBarRouterModule,
//     // for Core use:
    LoadingBarModule,
    ToastrModule.forRoot({
      timeOut: 1000,  
      extendedTimeOut: 1000,
    }),
    DisplayBoardRegistrationModule,
  ],
  providers: [ CookieService,{ provide: LocationStrategy, useClass: HashLocationStrategy},NgbActiveModal],
  bootstrap: [AppComponent]
})
export class AppModule { }
